import { v4 as uuid } from "uuid";

import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IPageResource, PageStatus } from "../types";

export type IPageCreateMutationParameters = {
    title: string;
    content: string;
    rank: number;
    status?: PageStatus;
    uuid?: string;
};

export type IPageCreateMutationResult = IPageResource;

export const pageCreateMutation: IApiMutationFunction<IPageCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    content,
    rank,
    status,
}) => {
    return {
        method: "POST",
        url: "/pages",
        data: {
            title,
            content,
            rank,
            status,
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const usePageCreateMutation = createApiMutationHook<IPageCreateMutationParameters, IPageCreateMutationResult>(
    pageCreateMutation,
);
